module.exports = __webpack_public_path__ + "static/img/service_content4_img.31e748b.png";